"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _mobxReact = require("mobx-react");
var _styled = _interopRequireDefault(require("@emotion/styled"));
var _icon_wrapper = _interopRequireDefault(require("./icon_wrapper"));
var _templateObject, _class, _FlagMnIcon;
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _taggedTemplateLiteral(e, t) { return t || (t = e.slice(0)), Object.freeze(Object.defineProperties(e, { raw: { value: Object.freeze(t) } })); }
var Wrapper = _styled["default"].div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  border-radius: 50%;\n  display: inline-block;\n  overflow: hidden;\n  width: ", ";\n  height: ", ";\n"])), function (props) {
  return props.width;
}, function (props) {
  return props.width;
});
var FlagMnIcon = (0, _mobxReact.observer)(_class = (_FlagMnIcon = /*#__PURE__*/function (_React$Component) {
  function FlagMnIcon() {
    _classCallCheck(this, FlagMnIcon);
    return _callSuper(this, FlagMnIcon, arguments);
  }
  _inherits(FlagMnIcon, _React$Component);
  return _createClass(FlagMnIcon, [{
    key: "render",
    value: function render() {
      return /*#__PURE__*/_react["default"].createElement(Wrapper, {
        width: this.props.width
      }, /*#__PURE__*/_react["default"].createElement("svg", {
        viewBox: "0 0 101 100",
        version: "1.1",
        xmlns: "http://www.w3.org/2000/svg"
      }, /*#__PURE__*/_react["default"].createElement("g", null, /*#__PURE__*/_react["default"].createElement("rect", {
        id: "Rectangle",
        fill: "#0066B4",
        x: "40",
        y: "0",
        width: "36",
        height: "100"
      }), /*#__PURE__*/_react["default"].createElement("rect", {
        id: "Rectangle",
        fill: "#DB1A2E",
        x: "76.1",
        y: "0",
        width: "23.9",
        height: "100"
      }), /*#__PURE__*/_react["default"].createElement("rect", {
        id: "Rectangle",
        fill: "#DB1A2E",
        x: "0",
        y: "0",
        width: "40",
        height: "100"
      }), /*#__PURE__*/_react["default"].createElement("g", {
        id: "Group",
        transform: "translate(12.000000, 25.000000)",
        fill: "#FFDA00"
      }, /*#__PURE__*/_react["default"].createElement("path", {
        d: "M11.3,17.7 C9,17.7 6.9,16.3 6,14.3 C6,14.3 6,14.4 6,14.4 C6,17.3 8.3,19.7 11.3,19.7 C14.2,19.7 16.6,17.4 16.6,14.4 C16.6,14.4 16.6,14.3 16.6,14.3 C15.7,16.2 13.7,17.7 11.3,17.7 Z",
        id: "Path"
      }), /*#__PURE__*/_react["default"].createElement("circle", {
        id: "Oval",
        cx: "11.3",
        cy: "12.9",
        r: "3.8"
      }), /*#__PURE__*/_react["default"].createElement("path", {
        d: "M8.9,5.7 C8.9,7 10,8.1 11.3,8.1 C12.6,8.1 13.7,7 13.7,5.7 C13.7,4.8 13.1,4.6 13.1,4.3 C13.1,4 13.5,3.5 12.7,2.9 C13.1,3.5 12.5,3.6 12.5,4.2 C12.5,4.8 12.7,4.8 12.7,5.3 C12.7,5.6 12.5,5.8 12.2,5.8 C11.9,5.8 11.7,5.6 11.7,5.3 C11.7,4.8 12.2,4.4 12.2,3.6 C12.2,2.8 12.1,2.7 11.7,2.1 C11.3,1.5 10.8,1 11.2,0.6 C10.5,0.8 10.8,1.8 10.8,2.4 C10.8,3 10.3,3.3 10.3,4.1 C10.3,4.9 10.7,4.9 10.7,5.4 C10.7,5.7 10.5,5.9 10.2,5.9 C9.9,5.9 9.7,5.7 9.7,5.4 C9.7,4.9 9.9,4.9 9.9,4.3 C9.9,3.7 9.3,3.6 9.7,3 C9,3.6 9.3,4.1 9.3,4.4 C9.5,4.6 8.9,4.7 8.9,5.7 Z",
        id: "Path"
      }), /*#__PURE__*/_react["default"].createElement("path", {
        d: "M0.8,20.9 L0.8,43.1 C0.8,43.3 1,43.5 1.2,43.5 L5.2,43.5 C5.4,43.5 5.6,43.3 5.6,43.1 L5.6,20.9 C5.6,20.7 5.4,20.5 5.2,20.5 L1.2,20.5 C1,20.5 0.8,20.7 0.8,20.9 Z",
        id: "Path"
      }), /*#__PURE__*/_react["default"].createElement("path", {
        d: "M17.1,20.9 L17.1,43.1 C17.1,43.3 17.3,43.5 17.5,43.5 L21.5,43.5 C21.7,43.5 21.9,43.3 21.9,43.1 L21.9,20.9 C21.9,20.7 21.7,20.5 21.5,20.5 L17.5,20.5 C17.3,20.5 17.1,20.7 17.1,20.9 Z",
        id: "Path"
      }), /*#__PURE__*/_react["default"].createElement("path", {
        d: "M6.6,24.8 L6.6,25.9 C6.6,26.1 6.8,26.3 7,26.3 L15.8,26.3 C16,26.3 16.2,26.1 16.2,25.9 L16.2,24.8 C16.2,24.6 16,24.4 15.8,24.4 L7,24.4 C6.7,24.4 6.6,24.6 6.6,24.8 Z",
        id: "Path"
      }), /*#__PURE__*/_react["default"].createElement("path", {
        d: "M6.6,38.2 L6.6,39.3 C6.6,39.5 6.8,39.7 7,39.7 L15.8,39.7 C16,39.7 16.2,39.5 16.2,39.3 L16.2,38.2 C16.2,38 16,37.8 15.8,37.8 L7,37.8 C6.7,37.8 6.6,38 6.6,38.2 Z",
        id: "Path"
      }), /*#__PURE__*/_react["default"].createElement("path", {
        d: "M7.3,20.5 L15.4,20.5 C15.6,20.5 15.7,20.8 15.5,20.9 L11.6,23.2 C11.4,23.3 11.2,23.3 11,23.2 L7.1,20.9 C7,20.8 7.1,20.5 7.3,20.5 Z",
        id: "Path"
      }), /*#__PURE__*/_react["default"].createElement("path", {
        d: "M7.3,40.7 L15.4,40.7 C15.6,40.7 15.7,41 15.5,41.1 L11.6,43.4 C11.4,43.5 11.2,43.5 11,43.4 L7.2,41 C7,40.9 7.1,40.7 7.3,40.7 Z",
        id: "Path"
      }), /*#__PURE__*/_react["default"].createElement("path", {
        d: "M11.8,27.3 C11.7,27.3 11.5,27.2 11.4,27.2 C8.8,27.2 6.6,29.3 6.6,32 C6.6,33.6 7.4,34.9 8.5,35.8 C8.6,35.9 8.8,35.7 8.7,35.6 C8.6,35.3 8.5,34.9 8.5,34.5 C8.5,33 9.8,31.7 11.3,31.7 C12.1,31.7 12.9,31.3 13.3,30.6 C14.1,29.1 13.2,27.6 11.8,27.3 Z M11.4,30.4 C10.9,30.4 10.5,30 10.5,29.5 C10.5,29 10.9,28.6 11.4,28.6 C11.9,28.6 12.3,29 12.3,29.5 C12.3,30 11.9,30.4 11.4,30.4 Z",
        id: "Shape"
      }), /*#__PURE__*/_react["default"].createElement("path", {
        d: "M14.2,28.2 C14.1,28.1 13.9,28.3 14,28.4 C14.1,28.7 14.2,29.1 14.2,29.5 C14.2,31 12.9,32.3 11.4,32.3 C10.6,32.3 9.8,32.7 9.4,33.4 C8.7,34.9 9.6,36.4 10.9,36.7 C11,36.7 11.2,36.8 11.3,36.8 C13.9,36.8 16.1,34.7 16.1,32 C16.1,30.5 15.4,29.1 14.2,28.2 Z M11.4,35.5 C10.9,35.5 10.5,35.1 10.5,34.6 C10.5,34.1 10.9,33.7 11.4,33.7 C11.9,33.7 12.3,34.1 12.3,34.6 C12.3,35.1 11.9,35.5 11.4,35.5 Z",
        id: "Shape"
      })))));
    }
  }]);
}(_react["default"].Component), _FlagMnIcon.defaultProps = {
  width: '20px'
}, _FlagMnIcon)) || _class;
var _default = exports["default"] = (0, _icon_wrapper["default"])(FlagMnIcon);